import { apiAuth, apiDownloadAuth } from "./base";

export function getAllBillings(params) {
  let api = apiAuth();
  return api.get('v1/billings', { params });
}

export function getAllBillingsV2(params) {
  let api = apiAuth();
  return api.get('v2/billings', { params });
}

export function getBillingById(id) {
  let api = apiAuth();
  return api.get(`/v1/billings/id/${id}`);
}

export function updateBillingById(id, data) {
  let api = apiAuth();
  return api.put(`/v1/billings/${id}`, data);
}

export function confirmBillingById(id) {
  let api = apiAuth();
  return api.put(`/v1/billings/${id}/confirm`);
}

export function reminderBillingById(id, data) {
  let api = apiAuth();
  return api.post(`/v1/billings/${id}/reminder`, data);
}

export function resetBillingById(id) {
  let api = apiAuth();
  return api.put(`/v1/billings/${id}/revert`);
}

export function downloadBilling(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/billings/export/xlsx", {params});
}

export function downloadBillingInvoiceById(id) {
  let api = apiAuth();
  return api.get(`/v1/billings/${id}/invoice`);
}

export function reminderWhatsappBilling(id) {
  let api =  apiAuth();
  return api.post(`v1/billings/${id}/reminders/whatsapp`);
}

export function getCommmission(params) {
  let api = apiAuth();
  return api.get('v1/registrations/commission', { params });
}

export function getDetailCommissions(id, params) {
  let api = apiAuth();
  return api.get(`v1/registrations/commission/${id}`, { params });
}

export function downloadComissionDetail(id) {
  let api =  apiDownloadAuth();
  return api.get(`v1/registrations/commission/${id}/export/xlsx`);
}

export function getHistoryTransferList(params) {
  let api = apiAuth();
  return api.get('v1/transfer-histories', { params });
}

export function downloadTransferList(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/transfer-histories/export/xlsx", {params});
}

export function updateHistoryById(id, data) {
  let api = apiAuth();
  return api.put(`v1/transfer-histories/${id}`, data);
}

export function getBillingsByIdNumber(id) {
  let api = apiAuth();
  return api.get(`v1/payments/${id}/bills`);
}

export function getReportCustomerPayments(params) {
  let api = apiAuth();
  return api.get('v1/reports/customer-payment/projects', { params });
}

export function getReportCustomerStatus(params) {
  let api = apiAuth();
  return api.get('v1/reports/customer-status/projects', { params });
}

export function getReportCustomerDue(params) {
  let api = apiAuth();
  return api.get('v1/reports/customer-due/projects', { params });
}

export function downloadReportCustomerPayments(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/reports/customer-payment/projects/export/xlsx", {params});
}

export function downloadReportCustomerStatus(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/reports/customer-status/projects/export/xlsx", {params});
}

export function downloadReportCustomerDue(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/reports/customer-due/projects/export/xlsx", {params});
}

export function getReportCommissions(params) {
  let api = apiAuth();
  return api.get('v1/reports/commission-disbursements', { params });
}

export function transferCommission(id) {
  let api = apiAuth();
  return api.post(`v1/reports/commission-disbursements/${id}/withdraw`);
}

export function downloadReportCommission(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/reports/commission-disbursements/export/xlsx", {params});
}

export function getReportMonthlyPayments(params) {
  let api = apiAuth();
  return api.get('v1/reports/customer-payment/month', { params });
}

export function downloadReportMonthlyPayments(params = {}) {
  let api =  apiDownloadAuth();
  return api.get("v1/reports/customer-payment/month/export/xlsx", {params});
}
